import { MAX_DAILY_PLAYS } from '../api/ranking';

export class Hud {
  private readonly scoreEl: HTMLElement;
  private readonly rankEl: HTMLElement;
  private readonly rankTotalEl: HTMLElement;
  private readonly heartsEl: HTMLElement;
  private readonly overlayEl: HTMLElement;

  constructor(parent: HTMLElement) {
    const root = document.createElement('div');
    root.className = 'hud';
    root.innerHTML = `
      <div class="hud-hearts" data-hud="hearts" aria-label="남은 플레이 횟수"></div>
      <div class="hud-rank">
        <span class="hud-label">RANK</span>
        <span class="hud-value hud-current" data-hud="rank">--</span>
        <span class="hud-rank-total" data-hud="rank-total"></span>
      </div>
      <div class="hud-scores">
        <span class="hud-label">SCORE</span>
        <span class="hud-value hud-current" data-hud="score">00000</span>
      </div>
      <div class="hud-overlay" data-hud="overlay"></div>
    `;
    parent.appendChild(root);
    this.scoreEl = required(root, '[data-hud="score"]');
    this.rankEl = required(root, '[data-hud="rank"]');
    this.rankTotalEl = required(root, '[data-hud="rank-total"]');
    this.heartsEl = required(root, '[data-hud="hearts"]');
    this.overlayEl = required(root, '[data-hud="overlay"]');
    this.setHearts(MAX_DAILY_PLAYS);
  }

  setScore(score: number): void {
    this.scoreEl.textContent = pad5(score);
  }

  setRank(rank: number, total: number): void {
    this.rankEl.textContent = pad3(rank);
    this.rankTotalEl.textContent = total > 0 ? `/ ${pad3(total)}` : '';
  }

  clearRank(): void {
    this.rankEl.textContent = '--';
    this.rankTotalEl.textContent = '';
  }

  // remaining = 오늘 남은 플레이 횟수. 좌상단 하트 N/M 표시.
  setHearts(remaining: number): void {
    const clamped = Math.max(0, Math.min(MAX_DAILY_PLAYS, remaining));
    const items: string[] = [];
    for (let i = 0; i < MAX_DAILY_PLAYS; i += 1) {
      const filled = i < clamped;
      items.push(
        `<span class="hud-heart${filled ? ' is-filled' : ''}" aria-hidden="true">${heartSvg(filled)}</span>`,
      );
    }
    this.heartsEl.innerHTML = items.join('');
  }

  showOverlay(html: string): HTMLElement {
    this.overlayEl.innerHTML = html;
    this.overlayEl.classList.add('visible');
    return this.overlayEl;
  }

  hideOverlay(): void {
    this.overlayEl.classList.remove('visible');
    this.overlayEl.innerHTML = '';
  }
}

function pad5(n: number): string {
  return Math.max(0, Math.floor(n)).toString().padStart(5, '0');
}

function pad3(n: number): string {
  return Math.max(0, Math.floor(n)).toString().padStart(3, '0');
}

function required(root: HTMLElement, selector: string): HTMLElement {
  const el = root.querySelector<HTMLElement>(selector);
  if (!el) throw new Error(`HUD element not found: ${selector}`);
  return el;
}

// 7x6 클래식 도트 하트 (Zelda / Dino 풍). 게임 entity 들의 픽셀 톤과 일관성 유지.
//   row 0: . X X . X X .
//   row 1: X X X X X X X
//   row 2: X X X X X X X
//   row 3: . X X X X X .
//   row 4: . . X X X . .
//   row 5: . . . X . . .
function heartSvg(filled: boolean): string {
  const color = filled ? '#E94B6A' : '#C8C8C8';
  const cells: ReadonlyArray<readonly [number, number]> = [
    [1, 0], [2, 0], [4, 0], [5, 0],
    [0, 1], [1, 1], [2, 1], [3, 1], [4, 1], [5, 1], [6, 1],
    [0, 2], [1, 2], [2, 2], [3, 2], [4, 2], [5, 2], [6, 2],
    [1, 3], [2, 3], [3, 3], [4, 3], [5, 3],
    [2, 4], [3, 4], [4, 4],
    [3, 5],
  ];
  const rects = cells
    .map(([x, y]) => `<rect x="${x}" y="${y}" width="1" height="1"/>`)
    .join('');
  return `<svg viewBox="0 0 7 6" fill="${color}" shape-rendering="crispEdges">${rects}</svg>`;
}
